export default ({
  FORM_LIVRE        : 1,
  FORM_PRONTUARIO   : 2
});